import {components} from "react-select";
import React from "react";

export const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
}

export const formatGroupLabel = (data: any) => (
    <div style={groupStyles}>
        <span>{data.label}</span>
    </div>
)

export const handleHeaderClick = (id: string) => {
    const node = document.querySelector(`#${id}`)?.parentElement?.nextElementSibling
    if (!node) return
    const classes = node.classList
    if (classes.contains("collapsed")) {
        node.classList.remove("collapsed")
    } else {
        node.classList.add("collapsed")
    }
}

export const CustomGroupHeading = (props: any) => {
    return (
        <div
            className="group-heading-wrapper"
            onClick={() => {
                handleHeaderClick(props.id)
            }}
        >
            <components.GroupHeading {...props} >
                {props.children}
            </components.GroupHeading>
        </div>
    )
}

export const selectStyler = {
    formatGroupLabel: formatGroupLabel,
    components: {GroupHeading: CustomGroupHeading},
    // noOptionsMessage: () => "Варианты не найдены"
    noOptionsMessage: () => "Загрузите значения Озон"

}


